<script setup>
	import { computed, onMounted, onUnmounted, ref } from 'vue';

	const props = defineProps({
		closeOnClick: {
			type: Boolean,
			default: false,
		},
	});

	const emits = defineEmits(['toggle']);

	const closeOnEscape = (e) => {
		if (open.value && e.key === 'Escape') {
			open.value = false;
		}
	};

	const closeOnValidate = () => {
		open.value = props.closeOnClick ? false : true;
		if (event.target.getAttribute('data-trigger') == 'close') {
			close();
		}
	};

	onMounted(() => document.addEventListener('keydown', closeOnEscape));
	onUnmounted(() => document.removeEventListener('keydown', closeOnEscape));

	var open = ref(false);

	const close = () => {
		open.value = false;
	};

	defineExpose({ close });
</script>

<template>
	<div class="relative">
		<div @click="open = !open" class="w-full">
			<slot name="trigger" />
		</div>

		<!-- Full Screen Dropdown Overlay -->
		<div v-show="open" class="fixed inset-0 z-40" @click="open = false"></div>

		<transition
			enter-active-class="transition ease-out duration-200"
			enter-from-class="transform opacity-0 scale-95"
			enter-to-class="transform opacity-100 scale-100"
			leave-active-class="transition ease-in duration-75"
			leave-from-class="transform opacity-100 scale-100"
			leave-to-class="transform opacity-0 scale-95">
			<div
				v-show="open"
				class="absolute z-50 mt-2 rounded-md shadow-lg origin-top-left left-0 w-full max-h-96 overflow-y-auto"
				style="display: none"
				@click="closeOnValidate()">
				<div
					class="rounded-md ring-1 ring-black ring-opacity-5 border border-slate-500 bg-slate-50 grid grid-cols-1 divide-y divide-slate-500 text-slate-500">
					<slot name="content" @close="test" />
				</div>
			</div>
		</transition>
	</div>
</template>
